import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: 0,
  },
  container: {
    width: '100%',
    maxWidth: theme.size.widgetWidth * 3 + theme.size.widgetGap * 2,
    '@media (max-width: 1800px)': {
      maxWidth: theme.size.widgetWidth * 2 + theme.size.widgetGap,
      width: '100%',
    },
  },
  shortBoxWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down(768)]: {
      flexDirection: 'column',
    },
  },
}));
